import removeKey from '../utils/removeKeyFromObject'
import actionTypes from './actions'

const reducer = (state = {}, action = { type: '' }) => {
  switch (action.type) {
    case actionTypes.addImage:
      return {
        ...state,
        [action.url]: false,
      }
    case actionTypes.markImageAsLoaded:
      return {
        ...state,
        [action.url]: true,
      }
    case actionTypes.deleteImage:
      return removeKey(state, action.url)
    case actionTypes.resetImages:
      return {}
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/asyncImages/reducer.js